import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Sales module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.sales in allRoutes.js.
 */
const TOOLS = ["cr", "crNew", "projectsAwaiting", "visitors", "tasks", "dmsAll", "epoCreate"];
const REPORTS = [
    "shukla-sales-dashboard", "sales-by-prodgroup", "customer-profile-sales", "shukla-sales-rental",
    "sales-dashboards-planning", "backlog-orders", "open-orders", "summary-otd",
];

const Sales = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-line-chart-line"
                        eyebrow="Revenue"
                        title="Sales"
                        subtitle="Pipeline, quotes, and revenue at a glance"
                        tone="amber"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Sales" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Sales tools"
                        description="Contract reviews, projects, visitors and tasks"
                        icon="ri-briefcase-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-line-chart-line"
                        title="More for Sales later"
                        message="Ideas for later: pipeline by stage, quote-to-order conversion and revenue forecasts. The cards above are live today."
                        tone="warning"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Sales;
